






































































































































import Vue from 'vue';
import FieldInput from '@/components/form/FieldInput.vue';
import Button from '@/components/form/Button.vue';
import RegisterPublisher from './RegisterPublisher.vue';
import {
  RegisterFormType,
  RegisterPublisherFormType,
  RegisterErrorsType,
} from '@/types/auth/register';
import {
  EmailValidate,
  PhoneValidate,
} from '@/components/form/validate/validate';
import { FormDataInterface, ResponseData } from '@/types';
import TogglePublisherAdvertiser from '@/components/user/TogglePublisherAdvertiser.vue';

const FIRST_FORM_STEP = 1;
const SECOND_FORM_STEP = 2;
const IS_AUTH = 1;

export default Vue.extend({
  name: 'Register',
  components: {
    FieldInput,
    Button,
    RegisterPublisher,
    TogglePublisherAdvertiser,
  },
  mounted() {
    const registerForm = this.getCacheRegisterForm;
    if (registerForm) {
      this.registerForm = registerForm;
    }
  },
  computed: {
    acceptButtonDisabled(): boolean {
      return this.registerPublisherForm.terms_and_conditions ? false : true;
    },
    isValidate() {
      return this.$store.state.auth.registerFormIsValid;
    },
    formStep() {
      return this.$store.state.auth.registerFormStep;
    },
    getCacheRegisterForm() {
      return this.$store.getters.getCacheRegisterForm;
    },
  },
  methods: {
    async submitValidation() {
      if (!this.validateForm()) return;

      if (this.toggleIsPublisher) {
        if (this.isValidate) {
          this.$store.commit('setFormStep', SECOND_FORM_STEP);
          return;
        }

        const formData: FormDataInterface = {};

        formData['email'] = this.registerForm.email;
        formData['phone'] = this.registerForm.phone;

        const response: ResponseData = await this.$store.dispatch(
          'validation',
          formData
        );

        this.$store.commit('setCacheRegisterForm', this.registerForm);

        if (response.success) {
          this.$store.commit('setFormIsValid', true);
          this.$store.commit('setFormStep', SECOND_FORM_STEP);
        } else {
          if (!response.data.length) return;

          response.data.forEach((error) => {
            this.errors[error.field].push(error.message);
          });
        }
        return;
      }

      this.submit();
    },
    async submit() {
      if (this.toggleIsPublisher) {
        if (!this.validationPublisherForm()) return;
      }

      let response: ResponseData;
      const formData = new FormData();

      formData.append('name', this.registerForm.name);
      formData.append('surname', this.registerForm.surname);
      formData.append('phone', this.registerForm.phone);
      formData.append('email', this.registerForm.email);
      formData.append('type_account', this.toggleIsPublisher ? '1' : '0');

      if (this.toggleIsPublisher) {
        formData.append('password', this.registerForm.password);
        formData.append('site', this.registerPublisherForm.site);
        formData.append('visitors', this.registerPublisherForm.visitors);
        formData.append(
          'terms_and_conditions',
          this.registerPublisherForm.terms_and_conditions.toString()
        );
        formData.append('auth', IS_AUTH.toString());

        response = await this.$store.dispatch(
          'registrationPublisher',
          formData
        );
      } else {
        response = await this.$store.dispatch(
          'registrationAdvertiser',
          formData
        );
      }

      if (response.success) {
        this.$store.commit('clearCacheRegisterForm');

        if (!this.toggleIsPublisher) {
          this.showAdvertiserSubmitedMessage = true;
          return;
        }

        window.location.href = '/';
      } else {
        if (!response.data.length) return;

        response.data.forEach((error) => {
          if (this.registerForm.hasOwnProperty(error.field)) {
            this.$store.commit('setFormStep', FIRST_FORM_STEP);
          }

          this.errors[error.field].push(error.message);
        });
      }
    },
    onInput(name) {
      this.$store.commit('setFormIsValid', false);
      this.errors[name] = [];
    },
    goBack() {
      this.$store.commit('setFormStep', FIRST_FORM_STEP);
    },
    validateForm() {
      this.resetErrors();
      let success = true;

      if (!this.registerForm.name) {
        this.setErrors('name', this.$t('errors.required'));
        success = false;
      }
      if (!this.registerForm.surname) {
        this.setErrors('surname', this.$t('errors.required'));
        success = false;
      }
      if (!this.registerForm.phone) {
        this.setErrors('phone', this.$t('errors.required'));
        success = false;
      }
      if (this.registerForm.phone && !PhoneValidate(this.registerForm.phone)) {
        this.setErrors('phone', this.$t('errors.incorectPhone'));
        success = false;
      }
      if (!this.registerForm.email) {
        this.setErrors('email', this.$t('errors.required'));
        success = false;
      }
      if (!EmailValidate(this.registerForm.email)) {
        this.setErrors('email', this.$t('errors.incorectEmail'));
        success = false;
      }
      if (!this.registerForm.password && this.toggleIsPublisher) {
        this.setErrors('password', this.$t('errors.required'));
        success = false;
      }
      return success;
    },
    validationPublisherForm() {
      this.resetErrors();
      let success = true;

      if (!this.registerPublisherForm.site) {
        this.setErrors('site', this.$t('errors.required'));
        success = false;
      }
      if (!this.registerPublisherForm.visitors) {
        this.setErrors('visitors', this.$t('errors.required'));
        success = false;
      }
      return success;
    },
    setErrors(field, message) {
      if (!this.errors[field]) return;

      this.errors[field].push(message);
    },
    resetErrors() {
      this.errors.name = [];
      this.errors.surname = [];
      this.errors.phone = [];
      this.errors.email = [];
      this.errors.password = [];
      this.errors.site = [];
      this.errors.visitors = [];
    },
  },
  data() {
    return {
      registerForm: {
        name: '',
        surname: '',
        phone: '',
        email: '',
        password: '',
      } as RegisterFormType,

      registerPublisherForm: {
        site: '',
        visitors: '',
        terms_and_conditions: 0,
      } as RegisterPublisherFormType,

      errors: {
        name: [],
        surname: [],
        phone: [],
        email: [],
        password: [],
        site: [],
        visitors: [],
      } as RegisterErrorsType,
      toggleIsPublisher: false,
      showAdvertiserSubmitedMessage: false,
    };
  },
});
